// extracted by mini-css-extract-plugin
export default {"sectionContainer":"RenderSection_sectionContainer__cEbws","sectionHeader":"RenderSection_sectionHeader__vpuWj"};